var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcWebReadinessVehicle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.678 9 5 13.806l1.312 1.823 5.804-4.177L27.814 15.8l.6-2.165L11.677 9z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.787 18.462v1.58H15.46v1.578h6.945l.79-2.37h2.889v5.328l-6.101 2.016-.06.206a3.957 3.957 0 0 1-3.574 2.713l-.098.002v1.582h-1.582v-1.58h-1.582v1.58h-1.582v-1.58h-.396a3.952 3.952 0 0 1-3.955-3.948c0-2.181 1.771-3.95 3.955-3.95h2.769v-1.578H7.549v-1.58h14.238zM9.922 25.569c0-.872.708-1.579 1.582-1.579a1.58 1.58 0 0 1 1.582 1.58 1.58 1.58 0 0 1-1.582 1.579 1.58 1.58 0 0 1-1.582-1.58z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.831 31.102c-.525.014-.7-.254-.7-1.19H7.549l.003.186c.057 1.707.91 2.703 2.436 2.576l9.426.002v-1.579H9.922l-.09.005zM31.15 25.032 29 27.181v-2.828l2.15-2.15 3.117 3.116 4.32-4.32H36v-2h6v5.992h-2v-2.578l-5.734 5.734-3.117-3.116zM39 26.994h3v10h-3v-10zM34 29.994h3v7h-3v-7zM32 31.994h-3v5h3v-5z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWebReadinessVehicle);
export default __webpack_public_path__ + "static/media/ic-web-readiness-vehicle.c1ccc69c60570b0879e953e59489ff15.svg";
export { ForwardRef as ReactComponent };